export default __webpack_public_path__ + "static/media/O_left.9cf9d761.png";